import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import logo from '../pages/logo.png'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [pcMenuOpen, setPcMenuOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header className="fixed w-full z-[100] top-0 border-b border-white/5 backdrop-blur-xl">
      <div className="max-w-screen-2xl mx-auto px-8 h-20 flex items-center justify-between gap-4">
        {/* Логотип */}
        <Link to="/" className="flex items-center gap-3 flex-shrink-0">
          <div className="w-25 h-25 flex items-center justify-center rounded group cursor-pointer">
            <img src={logo} alt='лого' className='w-20 h-20'/>
          </div>
          <span className="text-xl font-black tracking-tighter uppercase whitespace-nowrap">АВТО<span className="text-primary">ЛИДЕР</span></span>
        </Link>

        {/* Десктоп меню */}
        <nav className="hidden lg:flex items-center gap-12 text-[11px] font-bold tracking-[0.25em] uppercase text-slate-400">
          <Link to="/" className="hover:text-white transition-colors whitespace-nowrap">Главная</Link>
          <Link to="/courses" className="hover:text-white transition-colors whitespace-nowrap">Курсы</Link>
          <Link to="/instructors" className="hover:text-white transition-colors whitespace-nowrap">Инструкторы</Link>
          <Link to="/about" className="hover:text-white transition-colors whitespace-nowrap">О нас</Link>
          <Link to="/profile" className="hover:text-white transition-colors whitespace-nowrap">Профиль</Link>
        </nav>

        <div className="flex items-center gap-4 flex-shrink-0">
          <span className="hidden xl:block text-[11px] font-bold tracking-widest text-slate-500 uppercase whitespace-nowrap">+7 (959) 271-62-26</span>

          {/* Кнопка "Записаться" только для неавторизованных */}
          {!user && !mobileMenuOpen && (
            <Link to="/about" className="hidden md:block px-8 py-3 bg-white text-black hover:bg-primary hover:text-white font-black rounded uppercase tracking-widest text-[10px] transition-all duration-500 whitespace-nowrap">
              Записаться
            </Link>
          )}

          {/* Бургер-меню для ПК (только для staff) */}
          {user?.status === 'staff' && (
            <button 
              className="hidden lg:flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 text-white font-bold rounded transition-all duration-300 text-[10px] uppercase tracking-widest"
              onClick={() => setPcMenuOpen(!pcMenuOpen)}
            >
              {pcMenuOpen ? <X size={18} /> : <Menu size={18} />}
              Меню
            </button>
          )}

          {/* Мобильный гамбургер */}
          <button className="lg:hidden text-white flex-shrink-0" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Мобильное выпадающее меню */}
      {mobileMenuOpen && (
        <nav className="lg:hidden bg-black/80 border-t border-white/5 py-6 backdrop-blur-md max-h-[calc(100vh-80px)] overflow-y-auto">
          <div className="max-w-screen-2xl mx-auto px-8 flex flex-col gap-6 text-slate-300 text-sm uppercase tracking-widest pb-20">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">Главная</Link>
            <Link to="/courses" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">Курсы</Link>
            <Link to="/instructors" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">Инструкторы</Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">О нас</Link>
            <Link to="/profile" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">Профиль</Link>
            <Link to="https://www.drom.ru/pdd/" onClick={() => setMobileMenuOpen(false)} className="hover:text-primary transition">ПДД Билеты</Link>

            {!user && (
              <Link to="/about" className="px-8 py-3 bg-primary text-white font-black rounded uppercase tracking-widest text-[10px] transition-all">
                Записаться
              </Link>
            )}

            {/* Кнопки для staff в мобильном меню */}
            {user?.status === 'staff' && (
              <>
                {/* Группа: Регистрация */}
                <div className="mt-4 pt-4 border-t border-white/10">
                  <div className="text-[10px] font-bold text-green-400 uppercase tracking-wider mb-3 px-2">Регистрация</div>
                  <div className="flex flex-col gap-2">
                    <Link
                      to="/staff-register"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-green-700 transition"
                    >
                      Учеников
                    </Link>
                    <Link
                      to="/mastercar-register"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-green-700 transition"
                    >
                      Инструктора
                    </Link>
                    <Link
                      to="/staffextrabooking"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-green-700 transition"
                    >
                      Доп. запись
                    </Link>
                  </div>
                </div>

                {/* Группа: Редактирование */}
                <div className="pt-4 border-t border-white/10">
                  <div className="text-[10px] font-bold text-purple-400 uppercase tracking-wider mb-3 px-2">Редактирование</div>
                  <div className="flex flex-col gap-2">
                    <Link
                      to="/editor-user"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-purple-700 transition"
                    >
                      Пользователя
                    </Link>
                    <Link
                      to="/editor"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-purple-700 transition"
                    >
                      Страницы
                    </Link>
                    <Link
                      to="/file-editor"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-purple-700 transition"
                    >
                      Файлы
                    </Link>
                  </div>
                </div>

                {/* Группа: Просмотр */}
                <div className="pt-4 border-t border-white/10">
                  <div className="text-[10px] font-bold text-yellow-400 uppercase tracking-wider mb-3 px-2">Просмотр</div>
                  <div className="flex flex-col gap-2">
                    <Link
                      to="/staff-calendar"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-yellow-700 transition"
                    >
                      Календарь
                    </Link>
                    <Link
                      to="/reports"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-yellow-700 transition"
                    >
                      Отчётность
                    </Link>
                    <Link
                      to="/notifications"
                      onClick={() => setMobileMenuOpen(false)}
                      className="px-6 py-3 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] text-center hover:bg-yellow-700 transition"
                    >
                      Уведомления
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>
        </nav>
      )}

      {/* ПК-бургер меню для staff */}
      {pcMenuOpen && user?.status === 'staff' && (
        <>
          <div className="hidden lg:block fixed right-8 top-[80px] bg-black/95 border border-white/10 rounded-xl shadow-2xl backdrop-blur-xl p-4 min-w-[240px] animate-in slide-in-from-top-5 duration-200">
            <div className="text-[10px] font-bold tracking-widest text-slate-500 uppercase px-3 pb-2 border-b border-white/5 mb-3">
              Панель управления
            </div>
            
            {/* Группа: Регистрация */}
            <div className="mb-3">
              <div className="text-[9px] font-bold text-green-400 uppercase tracking-wider px-3 mb-2">Регистрация</div>
              <div className="space-y-1.5">
                <Link
                  to="/staff-register"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-green-700 transition-all text-center"
                >
                  Учеников
                </Link>
                <Link
                  to="/mastercar-register"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-green-700 transition-all text-center"
                >
                  Инструктора
                </Link>
                <Link
                  to="/staffextrabooking"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-green-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-green-700 transition-all text-center"
                >
                  Доп. запись
                </Link>
              </div>
            </div>

            {/* Группа: Редактирование */}
            <div className="mb-3">
              <div className="text-[9px] font-bold text-purple-400 uppercase tracking-wider px-3 mb-2">Редактирование</div>
              <div className="space-y-1.5">
                <Link
                  to="/editor-user"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-purple-700 transition-all text-center"
                >
                  Пользователя
                </Link>
                <Link
                  to="/editor"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-purple-700 transition-all text-center"
                >
                  Страницы
                </Link>
                <Link
                  to="/file-editor"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-purple-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-purple-700 transition-all text-center"
                >
                  Файлы
                </Link>
              </div>
            </div>

            {/* Группа: Просмотр */}
            <div>
              <div className="text-[9px] font-bold text-yellow-400 uppercase tracking-wider px-3 mb-2">Просмотр</div>
              <div className="space-y-1.5">
                <Link
                  to="/staff-calendar"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-yellow-700 transition-all text-center"
                >
                  Календарь
                </Link>
                <Link
                  to="/reports"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-yellow-700 transition-all text-center"
                >
                  Отчётность
                </Link>
                <Link
                  to="/notifications"
                  onClick={() => setPcMenuOpen(false)}
                  className="block px-4 py-2.5 bg-yellow-600 text-white font-black rounded uppercase tracking-widest text-[10px] hover:bg-yellow-700 transition-all text-center"
                >
                  Уведомления
                </Link>
              </div>
            </div>
          </div>

          {/* Клик вне меню закрывает его */}
          <div 
            className="hidden lg:block fixed inset-0 z-[-1]"
            onClick={() => setPcMenuOpen(false)}
          />
        </>
      )}
    </header>
  );
}